@if (building$ | async; as b) {
  <div class="or-content">
    <app-schedules-list [building]="b"></app-schedules-list>
  </div>
}
